import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../../config";
import { WebPreviewUploader } from "./WebPreviewUploader";

const headers = () => ({ "X-Admin-Token": localStorage.getItem("admin_token") || "" });
const STATUSES = [["new", "Nový"], ["proposal_sent", "Návrh poslaný"], ["approved", "Schválený · čaká na platbu"], ["won", "Zaplatené"], ["lost", "Nezáujem"]];

const ApproveBox = ({ r, onDone }) => {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState(r.proposal_url || "");
  const [note, setNote] = useState(r.note || "");
  const [busy, setBusy] = useState(false);
  if (r.status === "won") return <p className="text-xs text-emerald-700 mt-1" data-testid={`web-inquiry-plan-${r.id}`}>Pro do {(r.plan_expires_at || "").slice(0, 10)}</p>;
  const send = async () => {
    setBusy(true);
    try {
      const res = await axios.post(`${API}/admin/web-inquiries/${r.id}/approve`, { proposal_url: url.trim(), note }, { headers: headers() });
      toast.success(res.data.email_sent ? "Email s tlačidlom na platbu odoslaný" : "Schválené, ale email sa neodoslal. Pošli odkaz ručne.");
      onDone({ status: "approved", pay_token: res.data.pay_link.split("/").pop(), proposal_url: url.trim(), note });
      setOpen(false);
    } catch (e) { toast.error(e.response?.data?.detail === "invalid_url" ? "Odkaz musí začínať https://" : "Schválenie zlyhalo"); }
    setBusy(false);
  };
  const link = r.pay_token ? `${window.location.origin}/navrh-webu/${r.pay_token}` : "";
  return (
    <div className="mt-2 space-y-1">
      {link && <button onClick={() => { navigator.clipboard.writeText(link); toast.success("Platobný odkaz skopírovaný"); }} className="text-xs text-blue-600 underline" data-testid={`web-inquiry-copy-link-${r.id}`}>Kopírovať platobný odkaz</button>}
      {!open ? <button onClick={() => setOpen(true)} className="block text-xs px-2 py-1 rounded bg-gray-900 text-white" data-testid={`web-inquiry-approve-open-${r.id}`}>{r.status === "approved" ? "Poslať znova" : "Schváliť a poslať platbu"}</button> : (
        <div className="space-y-1 w-56">
          <input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="Odkaz na návrh (nepovinné)" className="w-full border border-gray-300 rounded px-2 py-1 text-xs bg-white text-gray-900" data-testid={`web-inquiry-proposal-url-${r.id}`} />
          <textarea value={note} onChange={(e) => setNote(e.target.value)} placeholder="Poznámka pre zákazníka (nepovinné)" rows={2} className="w-full border border-gray-300 rounded px-2 py-1 text-xs bg-white text-gray-900" data-testid={`web-inquiry-note-${r.id}`} />
          <button onClick={send} disabled={busy} className="text-xs px-2 py-1 rounded bg-emerald-600 text-white disabled:opacity-60" data-testid={`web-inquiry-approve-send-${r.id}`}>{busy ? "Odosielam…" : "Odoslať email s platbou"}</button>
        </div>)}
    </div>
  );
};

export const WebInquiriesPanel = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { axios.get(`${API}/admin/web-inquiries`, { headers: headers() }).then((r) => setRows(r.data.rows)).catch(() => {}); }, []);
  const patch = (id, p) => setRows((rs) => rs.map((r) => (r.id === id ? { ...r, ...p } : r)));
  const setStatus = async (id, status) => {
    try {
      const res = await axios.put(`${API}/admin/web-inquiries/${id}`, { status }, { headers: headers() });
      patch(id, res.data);
      if (status === "won") toast.success(`Zaplatené · plán Pro zapnutý do ${(res.data.plan_expires_at || "").slice(0, 10)}`);
    } catch { toast.error("Zmena stavu zlyhala"); }
  };
  return (
    <div className="border border-gray-200 rounded-lg bg-white p-4" data-testid="web-inquiries-panel">
      <p className="font-bold text-gray-900 mb-2">Dopyty na web €499 ({rows.length})</p>
      {rows.length === 0 ? <p className="text-sm text-gray-500">Zatiaľ žiadne dopyty.</p> : (
        <div className="overflow-x-auto"><table className="w-full text-sm">
          <thead><tr className="text-left text-gray-500"><th className="py-1 pr-3">Dátum</th><th className="pr-3">Kontakt</th><th className="pr-3">Firma / web</th><th className="pr-3">Správa</th><th>Stav</th></tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.id} className="border-t border-gray-100 align-top" data-testid={`web-inquiry-row-${r.id}`}>
              <td className="py-2 pr-3 whitespace-nowrap text-gray-500">{r.created_at.slice(0, 10)}<br /><span className="text-xs">{r.funnel}</span></td>
              <td className="pr-3 text-gray-900">{r.name}<br /><a href={`mailto:${r.email}`} className="text-blue-600">{r.email}</a><br />{r.phone}</td>
              <td className="pr-3 text-gray-700">{r.company}<br /><span className="text-xs">{r.current_url}</span>
                {r.referred_by && <><br /><span className="text-xs text-emerald-700" data-testid={`web-inquiry-ref-${r.id}`}>Odporúčanie {r.referred_by} · €449,10</span></>}
                {r.ref_code && <><br /><span className="text-xs text-gray-500">Kód: {r.ref_code} · odporučil {r.referrals_paid || 0}×</span></>}</td>
              <td className="pr-3 text-gray-700 max-w-xs">{r.message}</td>
              <td className="py-2"><select value={r.status} onChange={(e) => setStatus(r.id, e.target.value)} disabled={r.status === "won"} className="border border-gray-300 rounded px-2 py-1 bg-white text-gray-900" data-testid={`web-inquiry-status-${r.id}`}>
                {STATUSES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
                <ApproveBox r={r} onDone={(p) => patch(r.id, p)} />
                <WebPreviewUploader r={r} onChange={(previews) => patch(r.id, { previews })} /></td>
            </tr>))}</tbody>
        </table></div>
      )}
    </div>
  );
};
